import Equipe from "./equipe";

export default class Pool {
    joueurs= [];
    options=  null;
    parties=[];
    historiqueJoueurs=[];
    indexPool=0;
    constructor (options, indexPool) {
        this.options = options;
        
        this.indexPool = indexPool;
    }
    initHisto() {
        this.parties.forEach(partie=>{
            partie.equipes.forEach(equipe=>{
                equipe.initHisto(this.historiqueJoueurs);
            })
        })
    }
    getJson() {
        var partiesJSON = {
            parties: [],
            joueurs: this.joueurs,
            qualifies: this.qualifies
        };
        this.parties.forEach((partie)=>{
            var partieJSON = {
                equipes: []
            }
            partie.equipes.forEach(equipe=>{
                partieJSON.equipes.push(equipe.getJson())
            })
            
            partiesJSON.parties.push(partieJSON);
        })
        
        return partiesJSON;
    }
    random(min, max) {
        return Math.floor(min + Math.random() * (max - min));
    }
    
   
    init() {
       
        for (var indexPartie=0;indexPartie<3;indexPartie++) {
            var partie = {
                equipes: [],
                id: indexPartie
            }
            var listNumeros = this.joueurs.slice(); // copy du tableau
           
            var indexEquipe = 0;
           
            while (listNumeros.length>0) {
                partie.equipes[indexEquipe] = new Equipe(this.options, this.indexPool);
                partie.equipes[indexEquipe].init(listNumeros, this.historiqueJoueurs);
                indexEquipe++;
            }
         
            this.parties[indexPartie] = partie;
            this.initHisto();
        }
        
    }
    initJoueurs (listNumeros) {
        for (var indexJoueur=0;indexJoueur<this.options.nbJoueursParPool;indexJoueur++) {
            var indexTempo = this.random(0, listNumeros.length);
          
            var numeroJoueur = listNumeros[indexTempo];
           
            if (typeof(numeroJoueur)!="undefined") {
                listNumeros.splice(indexTempo, 1);
                this.joueurs.push(numeroJoueur);
            }
        }
    }
}